import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Container,
  Slide,
  Link,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Cookie, Security, PrivacyTip } from '@mui/icons-material';

const CookieBar = styled(Box)({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000000',
  color: '#ffffff',
  zIndex: 9999,
  padding: '24px 0',
  boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
});

const StyledLink = styled(Link)({
  color: '#FFD700',
  textDecoration: 'underline',
  '&:hover': {
    color: '#FFC000',
  },
});

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setOpen(false);
  };

  return (
    <Slide direction="up" in={open}>
      <CookieBar>
        <Container maxWidth="lg">
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: 3
          }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Cookie sx={{ mr: 1, fontSize: 28 }} />
                <Typography variant="h6" component="div">
                  Cookie Preferences
                </Typography>
              </Box>
              
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
                We use cookies and similar technologies to help personalize content, tailor and measure ads, and provide a better experience. 
                By clicking 'Accept', you agree to this use of cookies and data processing. 
              </Typography>
              
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Security sx={{ mr: 1, fontSize: 20, color: '#FFD700' }} />
                  <StyledLink href="/privacy-policy" target="_blank">
                    Privacy Policy
                  </StyledLink>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <PrivacyTip sx={{ mr: 1, fontSize: 20, color: '#FFD700' }} />
                  <StyledLink href="/cookie-policy" target="_blank">
                    Cookie Policy
                  </StyledLink>
                </Box>
              </Box>
            </Box>

            <Box sx={{ 
              display: 'flex', 
              gap: 2,
              flexDirection: { xs: 'row', md: 'row' },
              alignItems: 'center',
              minWidth: { md: '300px' },
              justifyContent: { xs: 'flex-start', md: 'flex-end' }
            }}>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  color: '#ffffff',
                  borderColor: '#ffffff',
                  borderRadius: 0,
                  px: 3,
                  '&:hover': {
                    borderColor: '#FFD700',
                    backgroundColor: 'rgba(255,215,0,0.1)',
                  }
                }}
                onClick={() => setOpen(false)}
              >
                Decline All
              </Button>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#FFD700',
                  color: '#000000',
                  borderRadius: 0,
                  px: 3,
                  '&:hover': {
                    backgroundColor: '#FFC000',
                  }
                }}
                onClick={handleAccept}
              >
                Accept All
              </Button>
            </Box>
          </Box>

          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block', 
              mt: 2, 
              color: 'rgba(255,255,255,0.7)',
              textAlign: { xs: 'left', md: 'right' }
            }}
          >
            You can change your preferences at any time by visiting Cookie Preferences in the footer.
          </Typography>
        </Container>
      </CookieBar>
    </Slide>
  );
};

export default CookieConsent; 